import client from './client'

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** Downloads Excel report via axios (handles auth refresh, binary decoding). */
export async function downloadExcel(month: string): Promise<void> {
  const response = await client.get('/api/v1/sessions/export', {
    params: { month },
    responseType: 'blob',
    headers: { Accept: XLSX_MIME },
  })
  const cd: string = response.headers['content-disposition'] ?? ''
  const filename = cd.match(/filename="([^"]+)"/)?.[1] ?? `on-call-${month}.xlsx`
  const blob = new Blob([response.data], { type: XLSX_MIME })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
